import { Component } from "react";
import { connect } from "react-redux";
import {
	Container,
	Button,
	Grid,
	Card,
	Theme,
	Tooltip,
	Box,
	makeStyles,
	Fab
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { Styles } from "@material-ui/core/styles/withStyles";
import CloseIcon from '@material-ui/icons/Close';
import RemoveIcon from '@material-ui/icons/Remove';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import PauseIcon from '@material-ui/icons/Pause';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import moment from "moment";
import Battery20Sharp from '@material-ui/icons/Battery20Sharp';
import Battery30Sharp from '@material-ui/icons/Battery30Sharp';
import Battery50Sharp from '@material-ui/icons/Battery50Sharp';
import Battery60Sharp from '@material-ui/icons/Battery60Sharp';
import Battery80Sharp from '@material-ui/icons/Battery80Sharp';
import Battery90Sharp from '@material-ui/icons/Battery90Sharp';
import BatteryFullSharp from '@material-ui/icons/BatteryFullSharp';
import BatteryAlertSharp from '@material-ui/icons/BatteryAlertSharp';
import { apiClient } from '../../../config/apiClient';
import BleSessionCodeModal from './bleSessionCodeModal'
import Config from "../../../config/config";
import { addWebWidgetParticipantsBysessionCode, checkConnectedSessions } from "../../../store/actions/participant/experience";
import AnalysisScoreIcon from '../creator/analyzeScoreIcon';
import { useStylesTooltip } from "../../../config/theme";
import UtilService from '../../../helper/service';
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import CryptoJS from 'crypto-js';
import { addLogToAws } from '../../../config/awslog';
import Draggable from 'react-draggable';
import ConfirmBtnModal from "./confirmBtnModal";

const encrypt = (text: string) => {
	return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(text));
};

const useStyles: Styles<Theme, any, any> = () => ({
	mainContainer: {
		padding: 0,
		position: 'fixed',
		zIndex: 1001,
		backgroundColor: '#F7F7F7',
		border: '1px solid #c1c1c1',
		boxShadow: '1px 1px 10px 1px #9e9e9e',
		borderRadius: 5,
		right: 20,
		top: 125,
		width: 380,
	},
	maxContainer: {
		padding: 0,
		overflowY: 'scroll',
		overflowX: 'hidden',
		height: 400,
		cursor:'grab'
	},
	minContainer: {
		display: 'none'
	},
	header: {
		padding: 10,
		paddingRight: 0,
		alignItems: "center"
	},
	bleTitle: {
		fontFamily: 'roboto-regular',
		fontWeight: 'bold'
	},
	hr: {
		marginTop: 15,
		marginBottom: 15
	},
	connectBtn: {
		background: '#017AEF',
		color: '#FFFFFF',
		textTransform: 'capitalize',
		fontFamily: 'roboto-regular',
		width: 110,
		'&:hover': {
			background: '#0f9fef',
			color: '#FFFFFF'
		},
	},
	toggleOnlineBtn: {
		background: '#017AEF',
		color: '#FFFFFF',
		textTransform: 'capitalize',
		fontFamily: 'roboto-regular',
		'&:hover': {
			background: '#0f9fef',
			color: '#FFFFFF'
		},
	},
	disConnectBtn: {
		width: 100,
		textTransform: 'capitalize',
		fontFamily: 'roboto-regular'
	},
	actionButton: {
		padding: 5,
	},
	deviceinfo: {
		lineHeight: 1.2,
		wordBreak: 'break-all',
		marginBottom: 10
	},
	infoPadding: {
		paddingTop: '2px !important',
		paddingBottom: '2px !important'
	},
	fRight: {
		float: 'right'
	},
	deviceCard: {
		margin: "2px 5px 10px 5px",
		padding: "10px 5px 10px 5px"
	},
	closeIcon: {
		cursor: 'pointer',
		position: "absolute",
		top: "-23px",
		right: "0px",
		color: "#FFFFFF",
		background: "#017AEF",
		borderRadius: '50%',
		padding: 3,
		height: 30,
		minHeight: 30,
		width: 30,
	},
	MinimizeIcon: {
		cursor: 'pointer',
		position: "absolute",
		top: "-23px",
		right: "35px",
		color: "#FFFFFF",
		background: "#017AEF",
		borderRadius: '50%',
		padding: 3,
		height: 30,
		minHeight: 30,
		width: 30,
	},
	add: {
		height: 20,
		minHeight: 20,
		width: 20,
	},
	select: {
		width: '100%'
	},
	closeDiv: {
		justifyContent: 'flex-end'
	}
})
const useStyles1 = makeStyles((theme) => ({
	statuscontent: {
		fontFamily: 'Spartan-bold',
		color: '#697683',
		textAlign: 'right',
		paddingTop: theme.spacing(1),
		display: "flex",
		flexDirection: "column",
		justifyContent: "flex-end"
	},
	statusicon: {
		width: 24,
		height: 24
	},
	statustitle: {
		fontFamily: 'Spartan-bold',
		fontSize: 25,
		color: '#1DB859',
		marginTop: 4
	},
	statustxt: {
		color: '#697683',
		fontSize: 20,
		fontFamily: 'Spartan-bold',
		paddingTop: theme.spacing(1),
		textTransform: 'capitalize'
	},
	icon: {
		width: 24,
		height: 24
	},
	tooltipDiv: {
		display: 'flex',
		alignItems: 'center'
	}
}));
const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";
interface IProps {
	notification: any,
	apolloClient: any,
	classes: any,
	setIsPaneOpen: any,
	setIsmin: any,
	ismin: any,
	setactiveDevice: any,
	dispatch: any,
	roles: any,
	setShownSnackAlert: any,
	handleSnackMsg: any,
	handleSnackAlertType: any

}
interface IState {
	state: any,
	dataRecords: any,
	connectedDevice: any,
	characteristic: any,
	bleDevice: any,
	bleServer: any,
	collectingDevice: any,
	batterCharacteristic: any,
	deviceBatteries: any,
	action: string,
	selectedDevices: any,
	timelapesDevice: any,
	showModal: any,
	selectedIndex: any,
	selectedOneDevice: any,
	immersionIndex: any,
	isload: any,
	istimeInterval: any,
	mesurmentData: any,
	modalSession_code: any
	confirmModal: any
}

function ScorePane1(props: any) {
	const { immersion, safety } = props;
	const classes = useStyles1();
	const tooltipClasses = useStylesTooltip();
	return (
		<Box display="flex" flexDirection="row">
			{immersion ? (
				immersion.color_indicator ? (
					<Box display="flex" flexDirection="row" justifyContent="flex-start" alignItems="center">
						<Tooltip classes={tooltipClasses} title="Immersion Index: Scale of 1 - 100" placement="bottom" arrow>
							<div className={classes.tooltipDiv}>
								<AnalysisScoreIcon color={immersion.immersion_index > 0 ? immersion.color_indicator : 'gray'} type={'immersion'} size={1} />
								<Box pl={1} className={classes.statustitle} style={{ color: UtilService.refactorGraphColor(immersion.color_indicator) }}>
									{immersion.immersion_index > 0 ? immersion.immersion_index : '--'}
								</Box>
							</div>
						</Tooltip>
					</Box>
				) : (
					<Box display="flex" flexDirection="row" justifyContent="flex-start" alignItems="center">
						<Tooltip classes={tooltipClasses} title="Immersion Index: Scale of 1 - 100" placement="bottom" arrow>
							<div className={classes.tooltipDiv}>
								<AnalysisScoreIcon color={immersion.overall_index > 0 ? immersion.overall_color_indicator : 'gray'} type={'immersion'} size={1} />
								<Box pl={1} className={classes.statustitle} style={{ color: UtilService.refactorGraphColor(immersion.overall_color_indicator) }}>
									{immersion.overall_index > 0 ? immersion.overall_index : '--'}
								</Box>
							</div>
						</Tooltip>
					</Box>
				)
			) : (
				<Box display="flex" flexDirection="row" justifyContent="flex-start" alignItems="center">
					<Tooltip classes={tooltipClasses} title="Immersion Index: Scale of 1 - 100" placement="bottom" arrow>
						<div className={classes.tooltipDiv}>
							<AnalysisScoreIcon color={'gray'} type={'immersion'} size={1} />
							<Box pl={1} className={classes.statustitle} style={{ color: UtilService.refactorGraphColor('gray') }}>--</Box>
						</div>
					</Tooltip>
				</Box>
			)}
			{safety ? (
				<Box pl={2} display="flex" flexDirection="row" justifyContent="flex-start" alignItems="center">
					<Tooltip classes={tooltipClasses} title="Psychological Safety Index: Scale of 1 - 100" placement="bottom" arrow>
						<div className={classes.tooltipDiv}>
							<AnalysisScoreIcon color={safety.safety_index > 1 ? safety.color_indicator : 'gray'} type={'safety'} size={1} />
							<Box pl={1} className={classes.statustitle} style={{ color: UtilService.refactorGraphColor(safety.safety_index > 1 ? safety.color_indicator : 'gray') }}>
								{safety.safety_index > 1 ? safety.safety_index : '--'}
							</Box>
						</div>
					</Tooltip>
				</Box>
			) : (
				<Box pl={2} display="flex" flexDirection="row" justifyContent="flex-start" alignItems="center">
					<Tooltip classes={tooltipClasses} title="Psychological Safety Index: Scale of 1 - 100" placement="bottom" arrow>
						<div className={classes.tooltipDiv}>
							<AnalysisScoreIcon color={'gray'} type={'safety'} size={1} />
							<Box pl={1} className={classes.statustitle} style={{ color: UtilService.refactorGraphColor('gray') }}>--</Box>
						</div>
					</Tooltip>
				</Box>
			)}
		</Box>
	)
}
class BleWidget extends Component<IProps, IState> {
	constructor(props: IProps) {
		super(props);
		this.state = {
			state: {},
			dataRecords: [],
			connectedDevice: [],
			characteristic: [],
			bleDevice: [
			],
			bleServer: [],
			collectingDevice: [],
			batterCharacteristic: [],
			deviceBatteries: {},
			action: "",
			selectedDevices: [],
			timelapesDevice: [],
			showModal: false,
			selectedIndex: -1,
			selectedOneDevice: [],
			immersionIndex: [],
			isload: true,
			istimeInterval: true,
			mesurmentData: [],
			confirmModal: false,
			modalSession_code: ""
		}
	}
	timeInterval: any;
	time15Interval: any;
	time10Interval: any;
	time5Interval: any;
	timesessionInterval: any;
	mesurment: any = [];

	componentWillUnmount() {
		this.setState({ bleDevice: null })
		this.setState({ istimeInterval: true })
		clearInterval(this.timeInterval);
		clearInterval(this.timesessionInterval)
		clearInterval(this.time15Interval);
		clearInterval(this.time10Interval);
		clearInterval(this.time5Interval);
	}
	validsession = async () => {
		let session_code: any = window.location.pathname.split('/')[4];
		if (UtilService.checkTrialAccess(loginUserData, this.props.roles['trial']['dashboard'])) {
			session_code = window.location.pathname.split('/')[5];
		}
		const currentSessionCode = localStorage.getItem("session_code") ? localStorage.getItem("session_code") : "";
		if (currentSessionCode == session_code) {
			const request: any = { session_code: [session_code] }
			await this.props.dispatch(checkConnectedSessions(this.props.apolloClient.client, request, async (response: any) => {
				if (response && response.length > 0 && (response[0].session_status == "LIVE" || response[0].session_status == "UPCOMING")) {
					this.setState({ modalSession_code: response[0].session_code })
				}
				this.setState({ showModal: true })
			}))
		} else {
			this.setState({ modalSession_code: ""})
			this.setState({ showModal: true })
		}
	}
	interval = () => {
		if (this.state.istimeInterval === true) {
			this.setState({ istimeInterval: false })
			this.timeInterval = setInterval(async () => {
				const collectingDevice = this.state.collectingDevice
				const timelapesDevice = this.state.timelapesDevice
				if (collectingDevice && collectingDevice.length > 0) {
					await collectingDevice.map(
						async (item: any) => {
							if (!timelapesDevice.find((device: any) => device.deviceId === item)) {
								const bleDevice = this.state.bleDevice
								const ble = await bleDevice.filter((obj: any) => obj.id === item)
								const val1: any = { 'deviceId': item, 'sec': 0, 'identifier': ble && ble.length > 0 ? ble[0].deviceIdentifier : null, 'timer': true }
								await this.state.timelapesDevice.push(val1)
							}
						})
					timelapesDevice.map(
						async (item: any) => {
							if (item.timer === true) {
								const itemsec = item.sec;
								item.sec = itemsec + 1
							}
						}
					)
					this.setState({ timelapesDevice: timelapesDevice })
				} else {
					this.setState({ istimeInterval: true })
					clearInterval(this.timeInterval);
					clearInterval(this.time15Interval);
					clearInterval(this.time10Interval);
					clearInterval(this.time5Interval);
				}
			}, 1000);
		}
	}
	intervalSessioncheck = async () => {
		this.timesessionInterval = setInterval(async () => {
			if (this.state.bleDevice) {
				const sessions: any = [];
				this.state.bleDevice.map((bleElement: any) => {
					if (bleElement.session && bleElement.session.length > 0) {
						bleElement.session.map((session: any) => {
							sessions.push(session.session_code)
						})
					}
				});
				if (sessions.length) {
					const request: any = { session_code: sessions }
					await this.props.dispatch(checkConnectedSessions(this.props.apolloClient.client, request, async (response: any) => {
						const bleDevice = this.state.bleDevice
						await response.map(async (ses: any) => {
							await ses.sessionParticipants.map(async (parti: any) => {
								await bleDevice.filter((ble: any) => ble.deviceIdentifier == parti.identifier).map(async (bleElement: any) => {
									if (!!bleElement.session && bleElement.session.length > 0)
										await bleElement.session.map(async (sess: any) => {
											if (sess.session_code === ses.session_code) {
												if (ses.session_status === 'LIVE' || ses.session_status === 'UPCOMING') {
													if (sess.session_status !== ses.session_status) {
														sess.session_status = ses.session_status
													}
													if (parti.participant_status == 'COMPLETED' || parti.participant_status == 'CANCELLED') {
														bleElement.session = await bleElement.session.filter((task: any) => task.session_code !== ses.session_code)
													}
												} else {
													bleElement.session = await bleElement.session.filter((task: any) => task.session_code !== ses.session_code)
												}
											}
										});
								}
								)
							})
						});
						this.setState({ bleDevice: bleDevice })
					}));
				}
			}
		}, 15000);
	}
	interval5sec = () => {
		this.time5Interval = setInterval(async () => {
			if (this.state.collectingDevice && this.state.collectingDevice.length > 0) {
				this.state.timelapesDevice.map(
					async (item: any) => {
						if (item.timer === true) {
							const mes = this.mesurment
							mes.filter((obj: any) => obj.identifier === item.identifier).map(async (mess: any) => {
								const payload = {
									"identifier": item.identifier,
									"device_type": "BLE",
									"measurements": mess.data
								};
								await apiClient(false).put('device-ingestion/v2/devices/measurements/' + item.identifier, payload);
								mess.data = []


							})
						}

					}

				)
			} else {
				clearInterval(this.time5Interval);
			}
		}, 5000);
	}
	interval10sec = () => {
		this.time10Interval = setInterval(async () => {
			if (this.state.collectingDevice && this.state.collectingDevice.length > 0) {
				this.state.timelapesDevice.map(
					async (item: any) => {
						if (item.timer === true) {
							const immfrom = moment().add(-10, 'seconds').unix();
							const immto = moment().unix();
							const immersionIndex = this.state.immersionIndex;
							const imm = await apiClient(false).get('index/v2/index/immersion/' + item.identifier + '?from_epoch=' + immfrom + '&to_epoch=' + immto);
							if (imm.data) {
								if (!immersionIndex.find((obj: any) => obj.identifier === item.identifier)) {
									immersionIndex.push({ 'identifier': item.identifier });
								}
								immersionIndex.filter((obj: any) => obj.identifier === item.identifier).map((immersion: any) => {
									Object.assign(immersion, { immdata: imm.data })
								})
								this.setState({ immersionIndex: immersionIndex })

							}
						}
					}
				)
			} else {
				clearInterval(this.time10Interval);
			}
		}, 10000);
	}
	interval15sec = () => {
		this.time15Interval = setInterval(async () => {
			if (this.state.collectingDevice && this.state.collectingDevice.length > 0) {
				this.state.timelapesDevice.map(
					async (item: any) => {
						if (item.timer === true) {
							const from = moment().add(-60, 'seconds').unix();
							const to = moment().unix();
							const safety = await apiClient(false).get('index/v2/index/safety/' + item.identifier + '?from_epoch=' + from + '&to_epoch=' + to);
							const immersionIndex = this.state.immersionIndex;
							if (safety.data) {
								if (!immersionIndex.find((obj: any) => obj.identifier === item.identifier)) {
									immersionIndex.push({ 'identifier': item.identifier });
								}
								immersionIndex.filter((obj: any) => obj.identifier === item.identifier).map((saf: any) => {
									Object.assign(saf, { safetydata: safety.data })
								})
								this.setState({ immersionIndex: immersionIndex })
							}
						}
					}
				)
			} else {
				clearInterval(this.time15Interval);
			}
		}, 60000);
	}
	handleModal = () => {
		this.setState({ showModal: false });
		setTimeout(() => {
		}, 500)
	};
	handleConfirmClose = () => {
		this.setState({ confirmModal: false })
	};
	handleConfirmOpen = () => {
		this.setState({ confirmModal: true })
	};
	onApply = () => {
		this.setState({ confirmModal: false })
	}
	togglemaxmin = () => {
		const count = this.state.collectingDevice.length
		this.props.setactiveDevice(count)
		this.props.setIsmin(!this.props.ismin)
	};
	showModal = async (device: any) => {
		await this.validsession();
		this.setState({ selectedOneDevice: device })
	}

	devicegattconnect: any = [];
	heartRateChange = async (event: any) => {
		if (this.state.collectingDevice.find((obj: any) => obj === event.target.service.device.id)) {
			const array = new Uint8Array(event.target.value.buffer);
			let bmp: any;
			if (array[0] & 1) {
				bmp = array[2] * 256 + array[1];
			} else {
				bmp = array[1];
			}
			const dataRecords = this.state.dataRecords;
			const mesurment = this.mesurment;
			const mesurmentData = this.state.mesurmentData;
			if (!mesurment.find((obj: any) => obj.identifier === event.target.service.device.deviceIdentifier)) {
				mesurment.push({ 'identifier': event.target.service.device.deviceIdentifier });
			}
			if (!mesurmentData.find((obj: any) => obj.identifier === event.target.service.device.deviceIdentifier)) {
				mesurmentData.push({ 'identifier': event.target.service.device.deviceIdentifier });
			}
			mesurment.filter((obj: any) => obj.identifier === event.target.service.device.deviceIdentifier).map((mes: any) => {
				if (!!mes.data && mes.data.length > 0) {
					mes.data.push({ "time_stamp": moment().unix(), "heart_rate": bmp })
				} else {
					Object.assign(mes, { data: [{ "time_stamp": moment().unix(), "heart_rate": bmp }] })
				}
			})
			mesurmentData.filter((obj: any) => obj.identifier === event.target.service.device.deviceIdentifier).map((mes: any) => {
				if (!!mes.data && mes.data.length > 0) {
					mes.data.push({ time_stamp: moment().unix(), heart_rate: bmp })
				} else {
					Object.assign(mes, { data: [{ time_stamp: moment().unix(), heart_rate: bmp }] })
				}
			})
			dataRecords.unshift(`${(moment().unix())} : ${bmp.toString()} -> ${event.target.service.device.name}`);
			if (dataRecords.length > 16) {
				dataRecords.pop();
			}
			this.setState({ mesurmentData: mesurmentData })
			this.setState({ dataRecords: dataRecords });
		}
	}
	batterLevelChange = (event: any) => {
		const array = new Uint8Array(event.target.value.buffer);
		const deviceBatteries = this.state.deviceBatteries
		deviceBatteries[event.target.service.device.id] = array[0]
		this.setState({ deviceBatteries: deviceBatteries })
	}
	batteryLevel = (par: any) => {
		if (par < 10) {
			return <BatteryAlertSharp style={{ color: "#ff0000", fontSize: 40 }}></BatteryAlertSharp>
		} else if (par < 20 && par >= 10) {
			return <Battery20Sharp style={{ color: "#ff0000", fontSize: 40 }}></Battery20Sharp>
		} else if (par < 30 && par >= 20) {
			return <Battery30Sharp style={{ color: "#e49b0f", fontSize: 40 }}></Battery30Sharp>
		} else if (par < 50 && par >= 30) {
			return <Battery50Sharp style={{ color: "#e49b0f", fontSize: 40 }}></Battery50Sharp>
		} else if (par < 60 && par >= 50) {
			return <Battery60Sharp style={{ color: "#e49b0f", fontSize: 40 }}></Battery60Sharp>
		} else if (par < 70 && par >= 60) {
			return <Battery60Sharp style={{ color: "#008000", fontSize: 40 }}></Battery60Sharp>
		} else if (par < 80 && par >= 70) {
			return <Battery80Sharp style={{ color: "#008000", fontSize: 40 }}></Battery80Sharp>
		} else if (par < 90 && par >= 80) {
			return <Battery90Sharp style={{ color: "#008000", fontSize: 40 }}></Battery90Sharp>
		} else if (par >= 90) {
			return <BatteryFullSharp style={{ color: "#008000", fontSize: 40 }}></BatteryFullSharp>
		}
	}
	biii_ble_disconnect = async (deviceId: string, identifier: string) => {
		let bleDevice = this.state.bleDevice;
		let selectedDevices = this.state.selectedDevices;
		let collectingDevice = this.state.collectingDevice;
		let connectedDevice = this.state.connectedDevice;
		let timelapesDevice = this.state.timelapesDevice;
		let bleServer = this.state.bleServer;
		let characteristic = this.state.characteristic;
		let batterCharacteristic = this.state.batterCharacteristic;
		let immersionIndex = this.state.immersionIndex;
		if (bleDevice && bleDevice.length > 0) {
			await bleDevice.find((obj: any) => !!obj && obj.id === deviceId).gatt.disconnect();
			bleDevice = await bleDevice.filter((obj: any) => !!obj && obj.id !== deviceId)
			await this.setState({ bleDevice: bleDevice })
		}
		if (bleServer && bleServer.length > 0) {
			bleServer = await bleServer.filter((obj: any) => !!obj && obj.device.id !== deviceId)
			await this.setState({ bleServer: bleServer })
		}
		if (characteristic && characteristic.length > 0) {
			characteristic = await characteristic.filter((obj: any) => !!obj && !!obj.service && obj.service.device.id !== deviceId)
			await this.setState({ characteristic: characteristic })
		}
		if (batterCharacteristic && batterCharacteristic.length > 0) {
			batterCharacteristic = await batterCharacteristic.filter((obj: any) => !!obj && !!obj.service && obj.service.device.id !== deviceId)
			await this.setState({ batterCharacteristic: batterCharacteristic })
		}
		if (selectedDevices && selectedDevices.length > 0) {
			selectedDevices = await selectedDevices.filter((device: any) => device !== deviceId)
			await this.setState({ selectedDevices: selectedDevices })
		}
		if (timelapesDevice && timelapesDevice.length > 0) {
			timelapesDevice = await timelapesDevice.filter((obj: any) => !!obj && obj.deviceId !== deviceId)
			await this.setState({ timelapesDevice: timelapesDevice })
		}
		if (collectingDevice && collectingDevice.length > 0) {
			collectingDevice = await collectingDevice.filter((device: any) => device !== deviceId)
			await this.setState({ collectingDevice: collectingDevice })
		}
		if (connectedDevice && connectedDevice.length > 0) {
			connectedDevice = await connectedDevice.filter((device: any) => device !== deviceId)
			await this.setState({ connectedDevice: connectedDevice })
		}
		if (immersionIndex && immersionIndex.length > 0) {
			immersionIndex = await immersionIndex.filter((device: any) => !!device && device.identifier !== identifier)
			await this.setState({ immersionIndex: immersionIndex })
		}
		if (!collectingDevice.length) {
			this.setState({ istimeInterval: true })
			clearInterval(this.timeInterval);
			clearInterval(this.time15Interval);
			clearInterval(this.time10Interval);
			clearInterval(this.time5Interval);
		}
	}
	biii_ble_connect = () => {
		const browserNavigator: any = navigator
		const Bluetooth: any = browserNavigator.bluetooth
		if (!Bluetooth) {
		} else {
			return Bluetooth.requestDevice({ filters: [{ services: ['heart_rate'] }], optionalServices: ['battery_service'] })
				.then(async (device: any) => {
					const bleDevice = this.state.bleDevice
					if (bleDevice.length < 5) {
						if (!bleDevice.find((ble: any) => ble.id === device.id)) {
							if (device && device.session && device.session.length > 0) {
								delete device.session
							}
							this.setState({ isload: device.id })

							const payload = {
								"requestor": "",
							};
							const res = await apiClient(false).post('/registration/v2/registration/identifiers', payload);
							Object.assign(device, { deviceIdentifier: res.data.identifier, temp_email: "web-widget" + res.data.identifier + "@getimmersion.com" });
							bleDevice.push(device);
							this.setState({ bleDevice: bleDevice })
						}
						return device.gatt.connect();
					} else {
						throw new Error("only allowed max 5 devices");
					}
				})
				.then((server: any) => {
					const bleServer = this.state.bleServer
					bleServer.push(server);
					this.setState({ bleServer: bleServer })
					return server.getPrimaryService('heart_rate')
				})
				.then((service: any) => {
					return service.getCharacteristic('heart_rate_measurement')
				})
				.then((character: any) => {
					const characteristic = this.state.characteristic
					characteristic.push(character)
					this.setState({ characteristic: characteristic })
					character.startNotifications().then(() => {
						character.addEventListener(`characteristicvaluechanged`,
							this.heartRateChange.bind(this));
						const connectedDevice = this.state.connectedDevice
						connectedDevice.push(character.service.device.id)
						this.setState({ connectedDevice: connectedDevice })
					});
					return this.state.bleServer.find((obj: any) => obj.device.id === character.service.device.id).getPrimaryService('battery_service');
				})
				.then(async (service: any) => {
					if (!!loginUserData) {
						let session_code: any = window.location.pathname.split('/')[4];
						if (UtilService.checkTrialAccess(loginUserData, this.props.roles['trial']['dashboard'])) {
							session_code = window.location.pathname.split('/')[5];
						}
						const currentSessionCode = localStorage.getItem("session_code") ? localStorage.getItem("session_code") : "";
						if (currentSessionCode == session_code) {
							const request = {
								session_code: currentSessionCode,
								identifier: service.device.deviceIdentifier,
								temp_email: service.device.temp_email,
								deviceId: service.device.id
							};
							await this.props.dispatch(addWebWidgetParticipantsBysessionCode(this.props.apolloClient.client, request, async(response: any) => {
								if (response.status === true) {
									await addLogToAws({ category: 'success', method: 'addWebWidgetParticipantsBysessionCode', message: 'using modal add WebWidgetParticipants By sessionCode', data: { response } });
									this.state.bleDevice.filter((device: any) => device.id == response.data.device_id).map((bleElement: any) => {
										if (!!bleElement.session && bleElement.session.length > 0) {
											if (bleElement.session.find((obj: any) => obj.session_code !== response.data.session_code)) {
												bleElement.session.push({ session_code: response.data.session_code, session_type: response.data.session_type, session_title: response.data.session_title, session_status: response.data.session_status })
											}
										} else {
											this.intervalSessioncheck()
											Object.assign(bleElement, {
												session: [{ session_code: response.data.session_code, session_type: response.data.session_type, session_title: response.data.session_title, session_status: response.data.session_status }]
											})
										}
									})
									this.setState(this.state.bleDevice)
								}
							}));
						}
					}
					return service.getCharacteristic('battery_level')
				})
				.then((character: any) => {
					const batterCharacteristic = this.state.batterCharacteristic
					batterCharacteristic.push(character);
					this.setState({ batterCharacteristic: batterCharacteristic })
					character.readValue().then((value: any) => {
						const array = new Uint8Array(value.buffer);
						const deviceBatteries = this.state.deviceBatteries
						deviceBatteries[character.service.device.id] = array[0]
						this.setState({ deviceBatteries: deviceBatteries })
					});
					return character.startNotifications().then(() => {
						this.setState({ isload: false })
						character.addEventListener(`characteristicvaluechanged`,
							this.batterLevelChange.bind(this));
					});
				})
				.catch(async (e: any) => {
					let bleDevice = this.state.bleDevice;
					const selectedDevices = this.state.selectedDevices;
					const collectingDevice = this.state.collectingDevice;
					const connectedDevice = this.state.connectedDevice;
					let bleServer = this.state.bleServer;
					let characteristic = this.state.characteristic;
					let batterCharacteristic = this.state.batterCharacteristic;
					const deviceBatteries = this.state.deviceBatteries;
					const updatebleDevice: any = [];
					const updatebleServer: any = [];
					const updatecharacteristic: any = [];
					const updatebatterCharacteristic: any = [];
					if (deviceBatteries && Object.keys(deviceBatteries).length > 0) {
						await Object.entries(deviceBatteries).forEach(async ([key]) => {
							if (bleDevice && bleDevice.length > 0) {
								bleDevice = await bleDevice.find((obj: any) => !!obj && obj.id === key)
								if (!!bleDevice) {
									updatebleDevice.push(bleDevice)
								}
							}
							if (bleServer && bleServer.length > 0) {
								bleServer = await bleServer.find((obj: any) => !!obj && !!obj.device && obj.device.id === key)
								if(!!bleServer){
									updatebleServer.push(bleServer)
								}
							}
							if (characteristic && characteristic.length > 0) {
								characteristic = await characteristic.find((obj: any) => !!obj && !!obj.service && !!obj.service.device && obj.service.device.id === key)
								if(!!characteristic){
								updatecharacteristic.push(characteristic)
								}
							}
							if (batterCharacteristic && batterCharacteristic.length > 0) {
								batterCharacteristic = await batterCharacteristic.find((obj: any) => !!obj && !!obj.service && !!obj.service.device && obj.service.device.id === key)
								if(!!batterCharacteristic){
								updatebatterCharacteristic.push(batterCharacteristic)
								}
							}

						});
						await this.setState({ bleDevice: updatebleDevice })
						await this.setState({ bleServer: updatebleServer })
						await this.setState({ characteristic: updatecharacteristic })
						await this.setState({ batterCharacteristic: updatebatterCharacteristic })
					} else {
						if (bleDevice && bleDevice.length > 0) {
							await this.setState({ bleDevice: [] })
						}
						if (bleServer && bleServer.length > 0) {
							await this.setState({ bleServer: [] })
						}
						if (selectedDevices && selectedDevices.length > 0) {
							await this.setState({ selectedDevices: [] })
						}
						if (characteristic && characteristic.length > 0) {
							await this.setState({ characteristic: [] })
						}
						if (batterCharacteristic && batterCharacteristic.length > 0) {
							await this.setState({ batterCharacteristic: [] })
						}
						if (selectedDevices && selectedDevices.length > 0) {
							await this.setState({ selectedDevices: [] })
						}
						if (collectingDevice && collectingDevice.length > 0) {
							await this.setState({ collectingDevice: [] })
						}
						if (connectedDevice && connectedDevice.length > 0) {
							await this.setState({ connectedDevice: [] })
						}
					}
					let errorMessage = ''

					if (e.message == "only allowed max 5 devices") {
						errorMessage = 'only allowed max 5 devices'
					}
					else if (e.message == "Web Bluetooth API globally disabled.") {
						errorMessage = 'Web Bluetooth globally disabled.'
					}
					else if (e.message == 'User cancelled the requestDevice() chooser.') {
						errorMessage = ''
					}
					else {
						errorMessage = e.message

					}
					if (errorMessage != '') {
						this.setState({ isload: false })
						this.props.setShownSnackAlert(true);
						this.props.handleSnackAlertType('error')
						this.props.handleSnackMsg(errorMessage)
					}
				});
		}
	}
	biii_ble_toggle_data_colect = (deviceId: string, type: string) => {
		let collectingDevice = this.state.collectingDevice
		const timelapesDevice = this.state.timelapesDevice
		if (type === 'start') {
			if (!collectingDevice.find((device: any) => device === deviceId)) {
				collectingDevice.push(deviceId)
			}
			timelapesDevice.filter((obj: any) => obj.deviceId === deviceId).map((de: any) => {
				de.timer = true
			})
			if (collectingDevice && collectingDevice.length === 1) {
				this.interval()
				this.interval5sec()
				this.interval15sec()
				this.interval10sec()
			}
		} else {
			collectingDevice = collectingDevice.filter((device: any) => device !== deviceId)
			timelapesDevice.filter((obj: any) => obj.deviceId === deviceId).map((de: any) => {
				de.timer = false
			})
		}
		if (!collectingDevice.length) {
			this.setState({ istimeInterval: true })
			clearInterval(this.timeInterval);
			clearInterval(this.time15Interval);
			clearInterval(this.time10Interval);
			clearInterval(this.time5Interval);
		}
		this.setState({ collectingDevice: collectingDevice })
	}
	onCheckDevice = (event: any, deviceId: string) => {
		let selectedDevices = this.state.selectedDevices
		if (event.target.checked) {
			if (!selectedDevices.find((device: any) => device === deviceId)) {
				selectedDevices.push(deviceId)
			}
		} else {
			selectedDevices = selectedDevices.filter((device: any) => device !== deviceId)
		}
		this.setState({
			selectedDevices: selectedDevices
		})
	}
	devicetime = (data: any) => {
		const timelapesDevice = this.state.timelapesDevice
		let time = moment.utc(0 * 1000).format('HH:mm:ss')
		if (timelapesDevice && timelapesDevice.length > 0) {
			const timedev = timelapesDevice.find((obj: any) => obj.identifier === data)
			if (timedev) {
				time = moment.utc(timedev.sec * 1000).format('HH:mm:ss')
			}
		}
		return (<>{time}</>)

	}
	deviceimm = (data: any) => {
		const immersionIndex = this.state.immersionIndex
		let time: any = <ScorePane1 immersion={null} safety={null} />
		if (immersionIndex && immersionIndex.length > 0) {
			const timeimm = immersionIndex.find((obj: any) => obj.identifier === data)
			if (timeimm) {
				time = <ScorePane1 immersion={!!timeimm.immdata ? timeimm.immdata : null} safety={!!timeimm.safetydata ? timeimm.safetydata : null} />
			}
		}
		return (time)
	}
	mesurmentCheckasync = (identifier: any, item: any, classes: any, email: any) => {
		const mesurmentData = this.state.mesurmentData
		const mesur = mesurmentData.find((obj: any) => obj.identifier === identifier);
		let btn: any = <></>
		if (!!mesur && !!mesur.data && mesur.data.length > 10) {
			if (item.session_status === 'LIVE') {
				if (item.session_type === 'ASYNC') {
					btn = <><Button
						variant="contained"
						className={clsx(classes.disConnectBtn, classes.actionButton)}
						onClick={() => this.asyncRedrict(item.session_code, identifier, email)}
					>View</Button></>
				} else {
					btn = <><Button
						variant="contained"
						className={clsx(classes.disConnectBtn, classes.actionButton)}
					>Participating
					</Button></>
				}
			}
		}
		return (<>{btn}</>)
	}
	asyncRedrict = async (session_code: any, identifier: any, email: any) => {
		const bleDevice = this.state.bleDevice
		const iden: any = [];
		const temp_email: any = [];
		if (bleDevice.length > 0) {
			bleDevice.map((obj: any) => {
				if (obj.session && obj.session.length > 0 && obj.session.find((ses: any) => ses.session_code == session_code)) {
					const mesurmentData = this.state.mesurmentData
					const mesur = mesurmentData.find((mesObj: any) => mesObj.identifier === obj.deviceIdentifier);
					if (!!mesur && !!mesur.data && mesur.data.length > 1) {
						iden.push(obj.deviceIdentifier)
						temp_email.push(obj.temp_email)
					}
				}
			})
		}
		const data: any = { session_code: session_code, identifier: iden, email: email, temp_email: temp_email }
		const asyncUrl: any = Config.DEV_ASYNK_URL + '/stimulus/' + session_code + '/' + identifier + '?web_ble=' + encrypt(JSON.stringify(data))
		await addLogToAws({ category: 'info', method: 'asyncRedrict', message: 'Redrict to async project with params', data: { redrict_url: asyncUrl, data: data } });
		window.open(asyncUrl, '_blank');
	}
	devicesList = (classes: any) => {
		return this.state.bleDevice && this.state.bleDevice.length > 0 && this.state.bleDevice.map((device: any, index: number) => {
			return (<div key={index}>
				{!device || (device && device.id === this.state.isload) ?
					<Card className={classes.deviceCard}>
						<Box display='flex' flexDirection='row' alignItems='center' justifyContent='center'>
							<CircularProgress color="primary" size={50} />
						</Box>
					</Card>
					:
					<Card className={classes.deviceCard}>
						<Grid container className={classes.deviceinfo}>
							<Grid item xs={1}>
								<Tooltip title="Unpair" placement="top" arrow={true}>
									<Fab className={classes.add} onClick={() => this.biii_ble_disconnect(device.id, device.deviceIdentifier)} >
										<CloseIcon />
									</Fab>
								</Tooltip>
							</Grid>
							<Grid item xs={11} container>
								<Grid item xs={12} container alignItems="center" justify="center">
								<Grid item xs={5}>
									{device.name}
								</Grid>
								<Grid item xs={1}>
									<AssignmentIndIcon />
								</Grid>
								<Grid item xs={5}>
									{device.deviceIdentifier}
								</Grid>
								<Grid item xs={1}>
									<Fab className={classes.add} onClick={() => this.showModal(device)} >
										<AddCircleIcon />
									</Fab>
								</Grid>
							</Grid>
							<Grid item xs={12} container alignItems="center" justify="center">
								<Grid item xs={1} >
									<Fab className={classes.add}>
										{this.state.collectingDevice && this.state.collectingDevice.includes(device.id) ?
											<Tooltip title="Stop" placement="top" arrow={true}><PauseIcon onClick={() => this.biii_ble_toggle_data_colect(device.id, 'stop')} /></Tooltip>
											:
											<Tooltip title="Start" placement="top" arrow={true}><PlayArrowIcon onClick={() => this.biii_ble_toggle_data_colect(device.id, 'start')} /></Tooltip>
										}
									</Fab>
								</Grid>
								<Grid item xs={6} >
									{device.deviceIdentifier && this.deviceimm(device.deviceIdentifier)}

								</Grid>
								<Grid item xs={4}>
									{device.deviceIdentifier && this.devicetime(device.deviceIdentifier)}

								</Grid>
								<Grid item xs={1}>
									{this.state && this.state.deviceBatteries && this.state.deviceBatteries[device.id] ? this.batteryLevel(this.state.deviceBatteries[device.id]) : <></>}
								</Grid>
							</Grid>
						</Grid>
					</Grid>
						{device.session && device.session.length > 0 ?
					device.session.map(
						(item: any) => <Grid container spacing={2} key={item.session_code}>
							<Grid item xs={4}>
								{item.session_title}
							</Grid>
							<Grid item xs={4}>
								{item.session_code}
							</Grid>
							<Grid item xs={4}>
								{device.deviceIdentifier && item.session_type && this.mesurmentCheckasync(device.deviceIdentifier, item, classes, device.temp_email)}
							</Grid>
						</Grid>
					)
					: <></>
				}
			</Card>
				}
			</div >
			)
	})
}
render() {
	const { classes, setIsPaneOpen, ismin } = this.props;
	return (
		<Draggable>
			<div className={ismin === true ? classes.minContainer : classes.mainContainer}>
				<Grid container className={classes.closeDiv}>
					<Tooltip title="Close" placement="top" arrow={true}>
						<Fab className={clsx(classes.closeIcon)} onClick={() => setIsPaneOpen(false)}>
							<CloseIcon />
						</Fab>
					</Tooltip>
					{ismin == false && <Tooltip title="Minimize" placement="top" arrow={true}>
						<Fab className={clsx(classes.MinimizeIcon)} onClick={this.togglemaxmin}>
							<RemoveIcon />
						</Fab>
					</Tooltip>}
				</Grid>
				<Container className={classes.maxContainer}>
					<Grid container className={classes.header}>
						<Grid item xs={5} className={classes.bleTitle}>
							<Button
								variant="contained"
								onClick={this.biii_ble_connect}
								className={clsx(classes.connectBtn)}
							>Add Device
							</Button>
						</Grid>
					</Grid>
					{classes && this.devicesList(classes)}
				</Container>
				{this.state.showModal && <BleSessionCodeModal
					modalSession_code={this.state.modalSession_code}
					open={this.state.showModal}
					onClose={this.handleModal}
					selectedIndex={this.state.selectedIndex}
					selectedOneDevice={this.state.selectedOneDevice}
					bleDevice={this.state.bleDevice}
					intervalSessioncheck={this.intervalSessioncheck}
				/>
				}
				<ConfirmBtnModal
					open={this.state.confirmModal}
					onClose={this.handleConfirmClose}
					onApply={this.onApply}
				/>
			</div>
		</Draggable>
	);
}
}
// load reducers
const mapStateToProps = () => ({
});
// load actions
const mapDispatchToProps = () => {
	return {
	};
};
const BleComponent = withStyles(useStyles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(BleWidget));
export {
	BleComponent
}
